import { writable } from "svelte/store";
var LogType;
(function (LogType) {
    LogType[LogType["plain"] = 1] = "plain";
    LogType[LogType["warn"] = 2] = "warn";
    LogType[LogType["error"] = 3] = "error";
    LogType[LogType["system"] = 4] = "system";
})(LogType || (LogType = {}));
export let logs = writable([]);
let logId = 1;
export function addLog(log, writeOnConsole = true) {
    if (writeOnConsole) {
        // console.log(`@${addLog.caller.name}:`, log);
        // console.log(`[${logId}]`, log);
        console.log(log);
    }
    logs.update((val) => [
        { log: log, type: LogType.plain, id: logId++ },
        ...val,
    ]);
    return logs;
}
export function addWarn(log, writeOnConsole = true) {
    if (writeOnConsole) {
        console.warn("[Warn]:" + log);
    }
    logs.update((val) => [{ log: log, type: LogType.warn, id: logId++ }, ...val]);
    return logs;
}
export function addError(log, writeOnConsole = true) {
    if (writeOnConsole) {
        // console.log(`@${addLog.caller.name}:`, log);
        // console.log(`[${logId}]`, log);
        console.error("[Error]:" + log);
    }
    logs.update((val) => [
        { log: log, type: LogType.error, id: logId++ },
        ...val,
    ]);
    return logs;
}
export function addSystemMsg(log, writeOnConsole = true) {
    if (writeOnConsole) {
        // console.log(`@${addLog.caller.name}:`, log);
        // console.log(`[${logId}]`, log);
        console.log("[System]:" + log);
    }
    logs.update((val) => [
        { log: log, type: LogType.system, id: logId++ },
        ...val,
    ]);
    return logs;
}
